import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { EditDocumentsComponent } from '../edit-documents/edit-documents.component';
import { EditCustomerInformationComponent } from '../edit-customer-information/edit-customer-information.component';
import { EditLocationDetailsComponent } from '../edit-location-details/edit-location-details.component';
import { EditMeansOfIdComponent } from '../edit-means-of-id/edit-means-of-id.component';
import { EditEmploymentDetailsComponent } from '../edit-employment-details/edit-employment-details.component';
import { EditNextOfKinComponent } from '../edit-next-of-kin/edit-next-of-kin.component';
import { EditBankDetailsComponent } from '@accounts/company-account/edit-account/edit-bank-details/edit-bank-details.component';
import {
  Accountbankinfo,
  DocKyc,
  Employerkyc,
  IndividualAccountKycData,
  Locationkyc,
  MeansOfIdkyc,
  Nextofkin,
  UserKyc,
} from '@core/models/admin/account';
import { BreadCrumbService } from '@core/services/bread-crumb.service';
import { AccountKYC } from '@core/models/admin/account/account.interface';
import { ActivatedRoute } from '@angular/router';
import { NotificationFacade } from '@core/facades/notification.facade';
import { AccountManagementService } from '@core/services/account-management.service';
import { LoadingService } from '@core/services/loading.service';
import { Observable, Subscription } from 'rxjs';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-edit-details',
  standalone: true,
  imports: [
    EditCustomerInformationComponent,
    EditLocationDetailsComponent,
    EditMeansOfIdComponent,
    EditEmploymentDetailsComponent,
    EditNextOfKinComponent,
    EditBankDetailsComponent,
    EditDocumentsComponent,
    NgxSkeletonLoaderModule,
    CommonModule,
  ],
  templateUrl: './edit-details.component.html',
  styleUrl: './edit-details.component.scss',
})
export class EditDetailsComponent implements OnInit, OnDestroy {
  accountData!: IndividualAccountKycData;
  locationDetails!: Locationkyc;
  meansOfIdDetails!: MeansOfIdkyc;
  employmentDetails!: Employerkyc;
  nextOfKinDetails!: Nextofkin;
  bankDetails!: Accountbankinfo[];
  documentDetails!: DocKyc[];
  customerDetails!: UserKyc;
  accountId!: string;
  subs: Subscription[] = [];
  isLoading$!: Observable<boolean>;

  private breadCrumbService = inject(BreadCrumbService);
  private accountService = inject(AccountManagementService);
  private route = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);
  private loadingService = inject(LoadingService);
  private toast = inject(NotificationFacade);

  constructor() {
    this.isLoading$ = this.loadingService.getLoadingObservable(
      'get-individual-account-kyc'
    );
  }

  ngOnInit(): void {
    this.accountId = this.route.snapshot.parent?.params['accountId'];
    this.breadCrumbService.setPageBreadCrumb(this.route);
    if (this.accountId) {
      this.getAccountInfo();
    }
  }
  getAccountInfo(): void {
    const sub = this.accountService
      .getIndividualAccountInfo(this.accountId)
      .subscribe({
        next: (response) => {
          this.accountData = response.data;
          this.accountService.setAccountKYCData(
            this.accountData as unknown as AccountKYC
          );
          this.locationDetails = response.data.location_kyc as Locationkyc;
          this.meansOfIdDetails = response.data.id_kyc as MeansOfIdkyc;
          this.employmentDetails = response.data.employer_kyc as Employerkyc;
          this.nextOfKinDetails = response.data.next_of_kin as Nextofkin;
          this.bankDetails = response.data
            .account_bank_info as Accountbankinfo[];
          this.documentDetails = response.data.doc as DocKyc[];
          this.customerDetails = response.data.user as UserKyc;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.toast.error('Failed to fetch account information');
        },
      });

    this.subs.push(sub);
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
